import { useOnboarding } from '../context/OnboardingContext'
import { WizardChrome } from './WizardChrome'
import { StepApplications } from './steps/StepApplications'
import { StepBor } from './steps/StepBor'
import { StepComplete } from './steps/StepComplete'
import { StepContacts } from './steps/StepContacts'
import { StepBusinessLicenses } from './steps/StepBusinessLicenses'
import { StepIndividualLicenses } from './steps/StepIndividualLicenses'
import { StepDrlpAssignment } from './steps/StepDrlpAssignment'
import { StepChecklist } from './steps/StepChecklist'
import { StepAttestation } from './steps/StepAttestation'
import { StepGeneralQuestions } from './steps/StepGeneralQuestions'
import { StepImportant } from './steps/StepImportant'
import { StepWelcome } from './steps/StepWelcome'
import { StepLogins } from './steps/StepLogins'
import { StepNewLoginWizard } from './steps/StepNewLoginWizard'
import { StepSeparateMiscAccountGuide } from './steps/StepSeparateMiscAccountGuide'
import { StepIdahoAgreement } from './steps/StepIdahoAgreement'
import { StepTexasAdminAccountAccess } from './steps/StepTexasAdminAccountAccess'
import { StepOregonNorthCarolinaUserAccountAccess } from './steps/StepOregonNorthCarolinaUserAccountAccess'
import { StepNewYorkAdminAccountAccess } from './steps/StepNewYorkAdminAccountAccess'
import { StepFloridaGeorgiaMississippiUserAccountAccess } from './steps/StepFloridaGeorgiaMississippiUserAccountAccess'
import { StepMaineTaxPortalAccess } from './steps/StepMaineTaxPortalAccess'
import { StepRhodeIslandTaxPortalAccess } from './steps/StepRhodeIslandTaxPortalAccess'
import { StepVermontMyVaxAccess } from './steps/StepVermontMyVaxAccess'
import { StepNewMexicoTapAccess } from './steps/StepNewMexicoTapAccess'
import { StepOtr } from './steps/StepOtr'
import { StepTraining } from './steps/StepTraining'

export function WizardView() {
  const { currentStepId, state } = useOnboarding()

  const body = (() => {
    switch (currentStepId) {
      case 'welcome':
        return <StepWelcome />
      case 'checklist':
        return <StepChecklist />
      case 'important':
        return <StepImportant />
      case 'generalQuestions':
        return <StepGeneralQuestions />
      case 'attestation':
        return <StepAttestation />
      case 'businessLicenses':
        return <StepBusinessLicenses key={state.demoNonce} />
      case 'individualLicenses':
        return <StepIndividualLicenses key={state.demoNonce} />
      case 'drlpAssignment':
        return <StepDrlpAssignment key={state.demoNonce} />
      case 'contacts':
        return <StepContacts />
      case 'logins':
        return <StepLogins />
      case 'separateMiscAccountGuide':
        return <StepSeparateMiscAccountGuide key={state.stepIndex} />
      case 'newLoginWizard':
        return <StepNewLoginWizard />
      case 'idahoAgreement':
        return <StepIdahoAgreement />
      case 'texasAdminAccountAccess':
        return <StepTexasAdminAccountAccess />
      case 'oregonNorthCarolinaUserAccountAccess':
        return <StepOregonNorthCarolinaUserAccountAccess />
      case 'newYorkAdminAccountAccess':
        return <StepNewYorkAdminAccountAccess />
      case 'floridaGeorgiaMississippiUserAccountAccess':
        return <StepFloridaGeorgiaMississippiUserAccountAccess />
      case 'maineTaxPortalAccess':
        return <StepMaineTaxPortalAccess />
      case 'rhodeIslandTaxPortalAccess':
        return <StepRhodeIslandTaxPortalAccess />
      case 'vermontMyVaxAccess':
        return <StepVermontMyVaxAccess />
      case 'newMexicoTapAccess':
        return <StepNewMexicoTapAccess />
      case 'bor':
        return <StepBor />
      case 'otr':
        return <StepOtr key={state.demoNonce} />
      case 'applications':
        return <StepApplications />
      case 'training':
        return <StepTraining />
      case 'complete':
        return <StepComplete />
      default:
        return <StepWelcome />
    }
  })()

  return <WizardChrome>{body}</WizardChrome>
}
